window.addEventListener("hoContentLoaded", () => {
	Vue.component('flash-animation', {
		data: function () {
			return {
				isRunning: false,
				tweenFull: null,
				tweenIn: null,
				tweenCenter: null,
				tweenOut: null,
				animationsData: null,
				elementData: null,
				elementTarget: null,
				classes: []
			}
		},
		computed: {
			isMobile() {
				return !store.getters['settings/breakPointIsDesktop'];
			},
			prefersReducedMotion() {
				return store.getters['settings/prefersReducedMotion'];
			},
		},
		methods: {
			viewportIn() {
				this.isRunning = true;
				if (!this.classes.includes("in-viewport"))
					this.classes.push("in-viewport");

				if (!this.prefersReducedMotion)
					requestAnimationFrame(this.viewportProgress);
			},

			viewportProgress() {
				const element = this.elementData.getBoundingClientRect();

				if (this.isRunning) {
					let perc = (-(element.y - window.innerHeight) / (window.innerHeight + element.height));

					if (this.tweenIn) {
						if (perc <= .25) {
							this.tweenIn.progress(perc * 4);
						} else {
							if (perc <= .75) {
								this.tweenIn.progress(1);
							}
						}
					}

					if (this.tweenCenter) {
						if (perc <= .3)
						{
							this.tweenCenter.progress(0);
						}
						else if (perc >= .3 && perc <= .66)
						{
							const p = perc - 0.3;
							this.tweenCenter.progress(p * 3.3);
						}
						else
						{
							if (perc <= .75)
							{
								this.tweenCenter.progress(1);
							}
						}
					}

					if (this.tweenOut) {
						if (perc >= .75) {
							if (this.tweenOut) {
								this.tweenOut.progress((1 - perc) * 4);
							}
						} else {
							if (perc >= 0.25 && perc <= .75) {
								if (this.tweenOut) {
									this.tweenOut.progress(1);
								}
							}
						}
					}

					if (!this.tweenIn && !this.tweenOut) {
						if (this.tweenFull) {
							this.tweenFull.progress(perc);
						}
					}

					requestAnimationFrame(this.viewportProgress);
				}
			},

			viewportOut(entry, scrollDirection) {
				if (this.classes.includes("in-viewport"))
					this.classes = this.classes.filter(c => c !== "in-viewport");

				this.isRunning = false;
			},

			resetTransforms() {
				if (this.tweenFull) this.tweenFull.kill();
				if (this.tweenIn) this.tweenIn.kill();
				if (this.tweenCenter) this.tweenCenter.kill();
				if (this.tweenOut) this.tweenOut.kill();
				gsap.set(this.elementTarget, { clearProps: "all" });

				if (this.tweenFull) this.tweenFull.clear();
				if (this.tweenIn) this.tweenIn.clear();
				if (this.tweenCenter) this.tweenCenter.clear();
				if (this.tweenOut) this.tweenOut.clear();

				this.tweenFull = null;
				this.tweenIn = null;
				this.tweenCenter = null;
				this.tweenOut = null;
			},

			setupTween(target, data, flipped = false, easing = 'none') {
				const tween = gsap.timeline({ paused: true });

				const from = {};
				const to = {};

				for (const p in data) {
					if (data.hasOwnProperty(p)) {
						if (p !== "ease") {
							const v = data[p];
							from[p] = v[0];
							to[p] = v[1];

							if (flipped) {
								from[p] = v[1];
								to[p] = v[0];
							}

							this.classes.push("parallax-" + p);

							if (p === "letterSpacing") {
								from[p] *= 0.1;
								to[p] *= 0.1;
								from[p] += "em";
								to[p] += "em";
							}
						}
					}
				}

				if (data.ease && easing === 'none') {
					to.ease = data.ease;
				} else
					to.ease = easing;

				to.duration = 1;
				tween.immediateRender = false;
				tween.fromTo(target, from, to);
				return tween;
			},

			setupAnimations() {
				// Reset all transforms before applying new animations
				this.resetTransforms();

				const animationsMobile = this.elementData.dataset.animationsmobile ? JSON.parse(this.elementData.dataset.animationsmobile) : null;
				const animationsDesktop = this.elementData.dataset.animations ? JSON.parse(this.elementData.dataset.animations) : null;

				// Assign the appropriate animations data based on the device type
				this.animationsData = this.isMobile ? animationsMobile : animationsDesktop;

				// If animationsData is still null or undefined, exit the function early
				if (!this.animationsData) {
					return;  // Exit if no animations data is available
				}


				let _full = this.animationsData.find(item => item.id === 'full');
				let _in = this.animationsData.find(item => item.id === 'in');
				let _center = this.animationsData.find(item => item.id === 'center');
				let _out = this.animationsData.find(item => item.id === 'out');
				let obj = [];

				if (!!_full && _full.types.length > 0) {
					obj = [];

					_full.types.forEach(type => {
						obj[type.name] = [type.start, type.end];
					});

					this.tweenFull = this.setupTween(this.elementTarget, obj);
				}

				if (!!_in && _in.types.length > 0) {
					obj = [];

					_in.types.forEach(type => {
						obj[type.name] = [type.start, type.end];
					});

					this.tweenIn = this.setupTween(this.elementTarget, obj);
				}

				if (!!_center && _center.types.length > 0) {
					obj = [];

					_center.types.forEach(type => {
						obj[type.name] = [type.start, type.end];
					});

					this.tweenCenter = this.setupTween(this.elementTarget, obj);
				}

				if (!!_out && _out.types.length > 0) {
					obj = [];

					_out.types.forEach(type => {
						obj[type.name] = [type.start, type.end];
					});

					this.tweenOut = this.setupTween(this.elementTarget, obj, true);
				}
			},

			setup()
			{
				if(this.elementData.dataset.target && this.elementData.dataset.target.length > 0)
				{
					this.elementTarget = this.$el.querySelector(this.elementData.dataset.target);

					if(this.elementTarget)
					{
						this.setupAnimations();
						window.viewport.add(this);
					}
				}
			}
		},

		watch: {
			isMobile(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.setupAnimations();  // Re-setup animations when mobile state changes
				}
			}
		},

		mounted() {
			this.elementData = this.$el.closest(".flash-animation-data");
			this.elementTarget = this.$refs.layer;

			if(this.elementData.dataset.target && this.elementData.dataset.target.length > 0)
			{
				this.setup();
			}
			else
			{
				this.setupAnimations();
				window.viewport.add(this);
			}
		},
	});
});
